<template>
  <div>
    <z-centralized-toolbar>
      <v-toolbar-items>
        <v-btn text small color="primary" @click="adicionar">
          <v-icon left>mdi-tag-plus</v-icon>
          Adicionar
        </v-btn>
        <v-btn text id="btn-atualizar" @click="refresh" :loading="$store.state.loading">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-toolbar-items>

      <z-text-field-search v-model="busca" select class="ml-5" @keydown.enter="buscar" @click:clear="limparBusca" />
    </z-centralized-toolbar>

    <v-divider />

    <z-scroll-layout :top-position="$v.TOP_POSITION">
      <z-container>
        <z-cabecalho>{{ $store.state.titulo_tela }}</z-cabecalho>

        <v-card>
          <v-data-table
            mobile-breakpoint="0"
            :options.sync="paginacao"
            :server-items-length="total_itens"
            :footer-props="$v.FOOTER_PROPS"
            :headers="headers"
            :items="categorias"
            item-key="id"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.nome }}</td>
                <td>{{ getTipoAplicacaoText(item.tipo_aplicacao) }}</td>
                <td>{{ item.ativo ? 'Sim' : 'Não' }}</td>
                <td class="text-center">
                  <v-btn icon @click="editar(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                  <v-btn icon @click="perguntarExcluir(item)"><v-icon>mdi-delete</v-icon></v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </z-container>
    </z-scroll-layout>

    <v-form v-model="form_valido" lazy-validation ref="formulario">
      <z-dialogo ref="dialogoAdicionar" largura="700px" titulo="Categoria" dividers persistent @abrir="$refs.formulario.resetValidation()">
        <template v-slot:conteudo>
          <v-row dense>
            <v-col cols="12" sm="8">
              <z-text-field v-model="categoria.nome" label="Nome" placeholder=" " :rules="[regras.campoObrigatorio]" />
            </v-col>
            <v-col cols="12" sm="4">
              <z-select
                v-model="categoria.tipo_aplicacao"
                :items="tiposAplicacao"
                item-value="value"
                item-text="text"
                label="Tipo aplicação"
                :rules="[regras.campoObrigatorio]"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="2" class="d-flex align-center">
              <v-switch class="my-0" hide-details  v-model="categoria.ativo" label="Ativo" />
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions_right>
          <v-btn text @click="$refs.dialogoAdicionar.fechar()" :disabled="salvando">Cancelar</v-btn>
          <v-btn color="primary" @click="confirmar" :loading="salvando" :disabled="!form_valido">Confirmar</v-btn>
        </template>
      </z-dialogo>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import * as regras from '@/app/helpers/validacoes';

export default {
  name: 'CategoriasFinanceirasLista',
  inject: ['notifications'],
  data() {
    return {
      headers: [
        { text: 'Nome', value: 'nome' },
        { text: 'Aplicação', value: 'tipo_aplicacao', width: '180px' },
        { text: 'Ativo', value: 'ativo', width: '120px' },
        { text: 'Opções', value: '', width: '160px', align: 'center', sortable: false },
      ],
      salvando: false,
      form_valido: true,
      regras: { ...regras },
      tiposAplicacao: [
        { text: 'Ambos', value: 'ambos' },
        { text: 'Pagar', value: 'pagar' },
        { text: 'Receber', value: 'receber' },
      ],
    };
  },
  computed: {
    ...mapState('categoriasfinanceiras', ['categoria', 'categorias', 'total_itens']),
    busca: {
      get() {
        return this.$store.state.categoriasfinanceiras.busca;
      },
      set(value) {
        this.$store.commit('categoriasfinanceiras/SET_BUSCA', value);
      },
    },
    paginacao: {
      get() {
        return this.$store.state.categoriasfinanceiras.paginacao;
      },
      set(value) {
        this.$store.commit('categoriasfinanceiras/UPDATE_PAGINACAO', value);
      },
    },
  },
  created() {
    this.refresh();
  },
  mounted() {
    this.setTitulo('Financeiro - Categorias');
  },
  methods: {
    ...mapMutations(['setTitulo']),
    ...mapActions('categoriasfinanceiras', ['listar', 'abrir', 'salvar', 'atualizar', 'excluir']),
    getTipoAplicacaoText(tipoAplicacao) {
      const encontrado = this.tiposAplicacao.find((item) => item.value === tipoAplicacao);
      return encontrado ? encontrado.text : tipoAplicacao;
    },
    async refresh() {
      await this.listar();
    },
    buscar() {
      this.$store.commit('categoriasfinanceiras/SET_PAGE', 1);
      this.refresh();
    },
    limparBusca() {
      this.busca = '';
      this.buscar();
    },
    adicionar() {
      this.$store.commit('categoriasfinanceiras/ZERAR');
      this.$refs.dialogoAdicionar.abrir();
    },
    async editar(item) {
      await this.abrir(item.id);
      this.$refs.dialogoAdicionar.abrir();
    },
    async confirmar() {
      if (!this.$refs.formulario.validate()) {
        return;
      }

      try {
        this.salvando = true;
        if (this.categoria.id) {
          await this.atualizar(this.categoria);
        } else {
          await this.salvar(this.categoria);
        }
        this.$refs.dialogoAdicionar.fechar();
        this.notifications.notificar('Categoria salva com sucesso.');
        await this.refresh();
      } catch (error) {
        this.notifications.notificarErro('Não foi possível salvar a categoria.', error);
      } finally {
        this.salvando = false;
      }
    },
    async perguntarExcluir(item) {
      const resposta = await this.notifications.dialogo_pergunta.abrir({
        titulo: 'Remover Categoria?',
        texto: 'A categoria será removida do sistema.',
        botoes: ['Cancelar', 'Remover'],
        padrao: 'Remover',
        cor: 'red',
      });

      if (resposta === 'Remover') {
        this.notifications.dialogo_pergunta.carregando();
        await this.excluir(item.id);
        this.notifications.dialogo_pergunta.fechar();
        this.notifications.notificar('Categoria excluída com sucesso.');
      } else {
        this.notifications.dialogo_pergunta.fechar();
      }
    },
  },
  watch: {
    paginacao: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>
